/**
 * MGT PDP Pathways Interactive
 * Card swap is pure CSS (hidden radios + :checked sibling rules). This layer
 * only adds a smooth scroll to the active card on select, so the
 * newly-revealed system card comes into view on tall (mobile) layouts.
 */
function initPathwaysInstance(root) {
  const panel = root.querySelector('[data-mgt-pathi-panel]');
  if (!panel) return;

  root.querySelectorAll('input[type="radio"]').forEach((radio) => {
    radio.addEventListener('change', () => {
      panel.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });
}

export default function initMgtPathways() {
  document.querySelectorAll('[data-mgt-pathi]').forEach(initPathwaysInstance);
}
